import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulateRegionList = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.regionList.length == 0 || (payload != undefined && (payload.reload == true || payload.refresh == true))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var regionDetails = { manufacturer: objAuth.manufacturer };
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'location_tree_da.php?a=expand_location_tree&manufacturer=' + objAuth.manufacturer + '&parent=0', { params: regionDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error occured while retrieving the region list', display: true };
			}).then(data => {
				commit('setRegionSelectors');
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Region reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
	}
}

export const setObjRegionParents = ({commit, dispatch, state, rootState}, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionType = payload.charAt(0).toUpperCase() + payload.substr(1);
	if( regionType == '' ) {
		regionType = 'Suburb';
	}
	var regionDetails = {manufacturer: objAuth.manufacturer, type: regionType};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=get_parent_links', {params: regionDetails}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while retrieving the region list', display: true};
		}).then(data => {
			for ( var d in data ) {
				if ( data[d].id != null ) {
					data[d].id = parseInt( data[d].id );
				}
			}
			commit('setRegionParents', data);
		});
}

export const fncGetRegionChildren = ({commit, dispatch, state, rootState}, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionDetails = {manufacturer: objAuth.manufacturer};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'location_tree_da.php?a=expand_location_tree&manufacturer='+objAuth.manufacturer+'&parent=' + payload, {params: regionDetails}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while retrieving the region list', display: true};
		}).then(data => {
			commit('setRegionChildren', data);
		});
}

export const fncDeleteRegion = ({commit, dispatch, state, rootState}, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionDetails = {manufacturer: objAuth.manufacturer};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'location_tree_da.php?a=expand_location_tree&manufacturer='+objAuth.manufacturer+'&parent=' + payload.id, {params: regionDetails}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while retrieving the region list', display: true};
		}).then(data => {
			if( data == null ) {
				var regionDetails = {id: payload.id};
				Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=delete_location', {params: regionDetails}, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						var snackDetails = {color: 'error', message: 'An error occured while trying to delete the region', display: true};
						commit('setSnack', snackDetails);
					}).then(data => {
						commit('hideModal');
						var snackDetails = {color: 'success', message: 'The region has been deleted successfully', display: true};
						commit('setSnack', snackDetails);
						dispatch({
							type: 'fncPopulateRegionList',
							refresh: true
						})
					});
			} else {
				var snackDetails = {color: 'error', message: 'The region cannot not be deleted as it has dependencies', display: true};
				commit('setSnack', snackDetails);
			}
		});
}

export const fncAddRegion = ({commit, dispatch, state, rootState}, payload) => {
	commit('setRunAdd', true);
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionDetails = { name: payload.regionName, description: payload.regionDescription, manufacturer: objAuth.manufacturer, type: payload.regionType, parent: payload.regionLink, factory_distances: '' }
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=create_location', {params: regionDetails}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while trying to add the region', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = {color: 'success', message: 'The region has been added successfully', display: true};
			commit('hideModal');
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateRegionList',
                refresh: true
			})
			dispatch({
				type: 'fncPopulateUserRegions',
				refresh: true
			})
			//commit('setRegionSelectors');
			commit('setRunAdd', false);
		});
}

export const fncEditRegion = ({ commit, dispatch, state, rootState }, payload) => {
	commit('setRunAdd', true);
	var regionId = payload.region.id;
	if( payload.region.loc_id ) {
		regionId = payload.region.loc_id;
	}
	var regionDetails = { id: payload.region.id, name: payload.region.name, description: payload.region.description, type: payload.region.type, parent: payload.region.parent, factory_distances: '' };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=edit_location', {params: regionDetails}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while trying to update the region', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = {color: 'success', message: 'The region has been updated successfully', display: true};
			commit('hideModal');
			commit('setSnack', snackDetails);
			commit('emptyRegionEdit');
			dispatch({
				type: 'fncPopulateUserRegions',
				refresh: true
			})
			commit('setRunAdd', false);
		});
}

export const setObjRegionEdit = ({ commit, dispatch, state, rootState }, payload) => {
	var regionDetails = { id: payload.regionObj.loc_id };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=get_location', { params: regionDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to update the region', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if (data != null) {
				commit('setObjRegionEdit', data);
				dispatch('setObjRegionParents', data.type);
				var modalDetails = { title: 'Edit Region - ' + data.name, component: 'modal-region-edit', mstate: true, params: { data: data } };
				commit({
					type: 'setModal',
					details: modalDetails
				});
			} else {
				var snackDetails = { color: 'error', message: 'An error occured while trying to update the region', display: true };
				commit('setSnack', snackDetails);
			}
		});
}
